const wordReducerDefaultState = {
    word: undefined
};

export default (state = wordReducerDefaultState, action) => {
    switch (action.type) {
        case 'WORD_SELECTED':
            return {
                ...state,
                word: action.word
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/word.js